<template>
    <div class="newplanning">
        <img class="headImg" src="../../assets/images/newplanning_title.png" alt="logo">
        <div class="back"><router-link to="/">返 回</router-link></div>
        <div class="main">
            <div class="newplanningList">
                <h3>选题汇总</h3>
                <div class="content">
                    <div class="datePickerBox">
                        <!--<el-date-picker-->
                                <!--v-model="selectedDate"-->
                                <!--:clearable="false"-->
                                <!--format="yyyy 年 MM 月 dd 日"-->
                                <!--popper-class="date-style"-->
                                <!--@change="onChange"-->
                                <!--value-format="yyyyMMdd">-->
                        <!--</el-date-picker>-->
                        <!--<span class="selectedWeek">({{selectedWeek}}) 选题</span>-->
                        <el-date-picker
                                v-model="selectedDate"
                                type="daterange"
                                range-separator="-"
                                format="yyyy 年 MM 月 dd 日"
                                value-format="yyyyMMdd"
                                popper-class="spread-detail-data-picker"
                                :editable="false"
                                :clearable="false"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                        <div class="jiansuo" @click="onChange">确 定</div>
                    </div>
                    <ul class="menu">
                        <li v-for="(item,index) in departmentList.list" :class="index===departmentList.index1?'on':''"><a :alt="item.name" @click="onAnchorClick(index)">{{item.name}}</a></li>
                        <!--<li v-for="(item,index) in departmentList.list" v-show="index<departmentList.max" :class="index===departmentList.index1?'on':''"><a :href="'#title'+index" :alt="item.name" @click="onAnchorClick(index)">{{item.name}}</a></li>-->
                        <!--<li v-show="departmentList.list.length > departmentList.max" @click="menuMoreClick()"><a>更多 >></a></li>-->
                    </ul>
                    <div class="module">
                        <el-collapse v-model="opened" v-for="(item,index) in departmentList.list" :id="'title'+index" :class="[index===departmentList.index1?'on':'','module-item']">
                            <el-collapse-item :title="item.name" :name="index">
                                <ul>
                                    <li v-for="(item2,index2) in item.list" :class="index2 === departmentList.index2 ? 'on' : ''">
                                        <a @click="showArticle(index,index2)">
                                            <i :class="departmentType(item2.REPORTTYPE)">{{item2.REPORTTYPE.slice(0,1)}}</i>
                                            <h4>{{item2.title}}</h4>
                                            <div class="resource">
                                                <span v-for="(item3,index3) in item2.mediaType" :class="getMediaType(item3.media)"></span>
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </div>
            </div>
            <img src="../../assets/images/middleLine.png" alt="">
            <div class="newplanningText">
                <h3>选题详情</h3>
                <div class="content">
                    <div>
                        <h4>{{article.title}}</h4>
                        <div class="info">
                            <span>创建人：{{article.userName}}</span>
                            <span>创建时间：{{article.crTime}}</span>
                            <span>交稿时间：{{article.STARTTIME}}至{{article.ENDTIME}}</span>
                        </div>
                        <div class="excuse">
                            <span class="title">执行人：</span>
                            <span class="detail">{{article.TRUENAME}}</span>
                        </div>
                        <div class="excuse">
                            <span class="title">发稿安排：</span>
                            <span class="detail" v-for="item in article.mediaType">{{item.media}}（{{item.type}}）</span>
                        </div>
                        <div class="articleContent" v-html="article.CONTENT"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getNow, getWeek} from '../../assets/js/common.js'
    export default {
        name: "newplanningMain",
        data() {
            return {
                selectedWeek: '星期三',
                selectedDate: [getNow('yyyymmdd'), getNow('yyyymmdd')],

                //左侧选题菜单
                // 选题列表
                departmentList:{
                    max:8,//最多显示条数
                    anchorIndex:0,//当前高亮索引
                    index1:null,
                    index2:null,
                    list:[]
                },
                article: {},
                timer: null,
            }
        },
        computed:{
            // 文章类型：普通、重要、紧急、敏感
            departmentType(){
                return function (type) {
                    switch (type ) {
                        case '重要':{
                            return 'zhong'
                        }
                        case '普通':{
                            return 'pu'
                        }
                        case '紧急':{
                            return 'jin'
                        }
                        case '敏感':{
                            return 'min'
                        }
                    }
                }
            },
            getMediaType(){
                return function (media) {
                    switch (media) {
                        case '客户端':{
                            return 'client'
                        }
                        case '微信':{
                            return 'weChat'
                        }
                        case '抖音':{
                            return 'douyin'
                        }
                        case '微博':{
                            return 'weibo'
                        }
                        case '网站':{
                            return 'website'
                        }
                        case '报纸':{
                            return 'newspaper'
                        }
                    }
                }
            },
            opened(){
                return this.departmentList.list.map((i,index)=>{
                    return index
                })
            }
        },
        mounted(){
            this.getDataList();
            this.timer =setInterval(() => {
                this.getDataList();
            }, 1000*60*15);

        },
        methods: {
            // 获取数据
            getDataList() {
                let _that = this;
                _that.departmentList.list = [];
                _that.departmentList.index1 = 0;
                _that.departmentList.index2 = 0;
                this.axios.get('/screen/theme/' + _that.$route.query.type, {params: {dateTime: _that.selectedDate[0], endDate: _that.selectedDate[1]}}).then(res => {
                    for(let key in res.data){
                        _that.departmentList.list.push({
                            name:key,
                            list:res.data[""+key+""]
                        });
                        if (key === _that.$route.query.group) {
                            _that.departmentList.index1 = _that.departmentList.list.length-1;
                            res.data[""+key+""].map((item,index) => {
                                if(item.title === _that.$route.query.title){
                                    // console.log('index2:', index);
                                    _that.departmentList.index2 = index;
                                }
                            });
                        }
                    }

                    _that.article = this.departmentList.list[_that.departmentList.index1].list[_that.departmentList.index2];
                })
            },
            // 日期选择
            onChange() {
                // this.selectedWeek = getWeek(value,'yyyymmdd');
                this.getDataList();
            },
            // 锚点
            onAnchorClick(index){
                this.departmentList.index1 = index;
                this.departmentList.index2 = 0;
                let id = "#title" + index; // id
                // 给对应dom滚动到对应锚点，使之出现在视图中
                document.querySelector(id).scrollIntoView({
                    behavior: "smooth", // 定义过渡动画 instant立刻跳过去 smooth平滑过渡过去
                    block: "end", // 定义垂直滚动方向的对齐 start顶部（尽可能）  center中间（尽可能）  end（底部）
                    inline: "center", // 定义水平滚动方向的对齐
                });
                this.article = this.departmentList.list[index].list[0];
            },
            // 选题菜单更多按钮
            menuMoreClick(){
                this.departmentList.max = this.departmentList.max*2;
            },
            // 点击标题
            showArticle(index,index2){
                this.departmentList.index1 = index;
                this.departmentList.index2 = index2;
                this.article = this.departmentList.list[index].list[index2];
            },

        },
        // 页面销毁前
        beforeDestroy(){
            clearInterval(this.timer);
        }
    }
</script>

<style scoped>
    .newplanning{
        background: url("../../assets/images/background.png") center center no-repeat;
        background-size: 100% 100%;
        width: 3200px;
        height: 1890px;
        position: relative;
        padding: 136px 60px 40px 60px;
        box-sizing: border-box;
    }
    .newplanning .headImg{
        position: absolute;
        top: 0;
        left: 0;
    }
    .newplanning .back{
        background: url("../../assets/images/backBG.png") center center no-repeat;
        background-size: 100% 100%;
        font-size: 30px;
        z-index: 0;
        position: absolute;
        top: 6px;
        left: 60px;
        padding: 10px 70px;
    }
    .newplanning .back a{
        color: #fff;
    }
    .newplanning .main{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .newplanning .main img{
        width: 89px;
        height: 845px;
    }
    /*左侧列表*/
    .newplanningList{
        background: url("../../assets/images/newplanning_leftBG.png") center center no-repeat;
        background-size: 100% 100%;
        width: 1240px;
        height: 1714px;
        color: #fff;
        position: relative;
        box-sizing: border-box;
        padding: 85px 64px 46px 64px;
    }
    .newplanningList h3{
        font-size: 38px;
        position: absolute;
        top: -35px;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
    }
    .newplanningList .content{
        height: 100%;
        /*overflow-y: auto;*/
        /*-ms-overflow-style: none;*/
        /*scrollbar-width: none;*/
    }
    /*.newplanningList .content::-webkit-scrollbar{*/
        /*display: none;*/
    /*}*/
    .newplanningList .content .datePickerBox{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .newplanning .content .datePickerBox .jiansuo {
        width: 146px;
        height: 80px;
        font-size: 30px;
        line-height: 80px;
        text-align: center;
        border: 2px solid #3263AE;
        border-radius: 10px;
        cursor: pointer;
        background: linear-gradient(
                180deg,
                rgba(10, 34, 72, 0.29) 0%,
                rgba(34, 69, 122, 0.62) 100%
        );
    }

    .newplanningList .content .selectedWeek{
        position: absolute;
        top: 21px;
        left: 340px;
        font-size: 32px;
    }
    .menu{
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        margin-top: 25px;
        height: 332px;
        overflow-y: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .menu::-webkit-scrollbar{
        display: none;
    }
    .menu li{
        width: 360px;
        height: 65px;
        margin: 9px 10px 9px 0;
        background-image: linear-gradient(rgba(35,71,126,1), rgba(35,71,126,0.1), rgba(35,71,126,0.1),rgba(35,71,126,1));
    }
    .menu li:nth-child(3n){
        margin-right: 0px!important;
    }
    .menu li a{
        display: block;
        height: 100%;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 65px;
        color: #84b2fa;
        background: rgba(9,24,46,0.5);
        font-size: 30px;
    }
    .menu li.on a{
        color: #f4de48;
        background-image: linear-gradient(rgba(161,78,47,1), rgba(161,78,47,0.1), rgba(161,78,47,0.1),rgba(161,78,47,1));
    }
    .module {
        margin-top: 47px;
        height: calc(100% - 500px);
        overflow-y: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
    }
    .module::-webkit-scrollbar{
        display: none;
    }
    .module ul {
        margin-top: 16px;
    }
    .module-item.on li.on{
        background: url("../../assets/images/newplanning_titleOnBG.png") center center no-repeat;
        background-size: 100% 100%;
    }
    .module-item.on li.on a h4{
        color: #f4de48;
    }
    .module li{
        padding: 12px 0;
        margin-top: 8px;
        background: url("../../assets/images/newplanning_ListTitleBG.png") center center no-repeat;
        background-size: 100% 100%;
        /*background: linear-gradient(to right, rgba(9, 50, 98 , 0.2), rgba(13, 71 ,136, 0.6), rgba(9, 53, 102, 0.2));*/
        /*border-image: linear-gradient(to right, rgba(9, 53, 105 , 0.1), rgba(14, 73 ,139, 0.2), rgba(9, 53, 105, 0.1)) 12 0;*/
    }
    .module li a{
        display: flex;
        align-items: center;
        padding: 12px 0;
        color: #fff;
        font-size: 32px;
    }
    .module li a *{
        float: left;
    }
    .module li a i{
        margin-left: 18px;
        margin-right: 40px;
        width: 56px;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
        box-sizing: border-box;
        border-radius: 5px;
    }
    .module li a:after{
        content: '';
        display: block;
        clear: both;
    }
    .module li a i.zhong{
        border: 3px solid #eacb42;
        color: #eacb42;
    }
    .module li a i.pu{
        border: 3px solid #2965ae;
        color: #2965ae;
    }
    .module li a i.jin{
        border: 3px solid #da2929;
        color: #da2929;
    }
    .module li a i.min{
        border: 3px solid #e96e0b;
        color: #e96e0b;
    }
    .module h4{
        /*width: 634px;*/
    }
    .module .resource{
        display: flex;
        justify-content: flex-end;
        flex: 1;
        margin-right: 32px;
    }
    .module .resource span{
        margin-left: 24px;
    }
    .module .resource .weChat{
        background: url("../../assets/images/icon_wechat.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .module .resource .newspaper{
        background: url("../../assets/images/icon_paper.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .module .resource .website{
        background: url("../../assets/images/icon_website.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .module .resource .weibo{
        background: url("../../assets/images/icon_weibo.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .module .resource .douyin{
        background: url("../../assets/images/icon_douyin.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    .module .resource .client{
        background: url("../../assets/images/icon_client.png") center center no-repeat;
        background-size: 100% 100%;
        width: 32px;
        height: 32px;
    }
    /*右侧列表*/
    .newplanningText{
        background: url("../../assets/images/newplanning_rightBG.png") center center no-repeat;
        background-size: 100% 100%;
        width: 1759px;
        height: 1714px;
        position: relative;
        color: #fff;
        box-sizing: border-box;
        padding: 85px 64px 46px 64px;
    }
    .newplanningText h3{
        font-size: 38px;
        position: absolute;
        top: -35px;
        left: 50%;
        transform: translateX(-50%);
        color: #fff;
    }
    .newplanningText .content{
        height: 100%;
        overflow-y: auto;
        -ms-overflow-style: none;
        scrollbar-width: none;
        /*margin-top: 82px;*/
    }
    .newplanningText .content::-webkit-scrollbar{
        display: none;
    }
    .newplanningText h4{
        font-size: 68px;
        text-align: center;
    }
    .newplanningText .info{
        color: #84b2fa;
        font-size: 36px;
        display: flex;
        justify-content: space-around;
        margin: 58px 130px 50px 130px;
    }
    .newplanningText .content .excuse{
        background: url("../../assets/images/newplanning_excuse.png") center center no-repeat;
        background-size: 100% 100%;
        padding: 30px 44px;
        margin-top: 28px;
    }
    .newplanningText .content .excuse .title{
        color: #88b5fb;
        font-size: 37px;
    }
    .newplanningText .content .excuse .detail{
        color: #fff;
        font-size: 37px;
    }
    .newplanningText .articleContent{
        margin-top: 62px;
        font-size: 40px;
        overflow-x: auto;
        font-family: 宋体;
    }
    .newplanningText .articleContent::-webkit-scrollbar{
        width: 16px;
        background-color: #203d5c;
    }
    /* 滚动条滑块 */
    .newplanningText .articleContent::-webkit-scrollbar-thumb {
        border-radius:20px;
        background:#5e92bb;
    }
</style>
